module.exports = __webpack_public_path__ + "img/strategy_mw_grey.d47b49e6.svg";